
<div class="newsletterDialog">
  <v-dialog v-model="dialog" max-width="600px" persistent :scrollable="true">
    <v-card class="newsletterCard">
      <v-icon
          :size="70"
          :width="7"
          class="successIcon"
      >check_circle_outline</v-icon>
      <v-card-title><h3 class="title">{{ $t('NEWSLETTER_CONSENT_TITLE') }}</h3></v-card-title>
      <v-card-text class="text">
        <p class="body-1 newsletterText center" v-html="$t('NEWSLETTER_CONSENT_TEXT')"></p>
        <v-form class="newsletterForm" v-model="formValid">
          <v-row wrap>
            <v-col cols="12" sm="6">
              <v-text-field v-model="firstName" :label="$t('NEWSLETTER_CONSENT_FIRSTNAME')" :rules="[globalRules.present]"/>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="lastName" :label="$t('NEWSLETTER_CONSENT_LASTNAME')" :rules="[globalRules.present]"/>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12">
              <v-text-field v-model="email" :label="$t('NEWSLETTER_CONSENT_EMAIL')" :rules="[globalRules.email]"/>
            </v-col>
          </v-row>
        </v-form>
        <p class="caption grey--text text--darken-1 text-center" v-html="$t('NEWSLETTER_CONSENT_PRIVACY_POLICY')"></p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false">{{ $t('NEWSLETTER_CONSENT_BUTTON_DISMISS') }}</v-btn>
        <v-spacer/>
        <v-btn color="primary" :disabled="!formValid" @click="submit">
          {{ $t('NEWSLETTER_CONSENT_BUTTON_SUBMIT') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
